export default {
  'survey.action.back_home': 'Back to Member Center',
  'survey.cta.register': 'Join now',
  'survey.cta.view_coupon': 'View my coupons',
  'survey.cta.view_points': 'View my points',
  'survey.cta.go_member_center': 'Go to Member Center',
  'survey.cta.go_member_card': 'Go to Member Card',
  'survey.cta.go_coupon': 'Go to Coupon Wallet',
  'survey.cta.register_to_claim': 'Register first to claim 🎁',
  'survey.cta.join_member': 'Join as a member!',
  'survey.welcome.question_count': '{count} questions',
  'survey.welcome.estimated_minutes': 'About {minutes} minutes',
  'survey.welcome.start': 'Start survey',
  'survey.welcome.privacy': 'By answering, you agree to the Privacy Policy',
  'survey.welcome.privacy_prefix': 'By answering, you agree to the ',
  'survey.reward.title': 'Your exclusive reward',
  'survey.reward.member_points': 'Member points',
  'survey.reward.point_unit': 'points',
  'survey.reward.points': '{points} points',
  'survey.reward.coupon': '{name}{qty}',
  'survey.reward.coupon_fallback': 'Coupon',
  'survey.reward.require_member': 'Join as a member to receive the reward',
  'survey.question.unsupported': 'This question type is not supported yet',
  'survey.question.auth_required':
    'Please complete LINE login before submitting the survey.',
  'survey.question.submit_failed': 'Submission failed. Please try again later.',
  'survey.question.required': 'Required',
  'survey.footer.submitting': 'Submitting...',
  'survey.footer.submit': 'Submit',
  'survey.footer.next': 'Next',
  'survey.footer.back': 'Back',
  'survey.progress.label': 'Question {current}/{total}',
  'survey.district.city': 'City/County',
  'survey.district.city_placeholder': 'Select a city/county',
  'survey.district.township': 'District',
  'survey.district.township_placeholder': 'Select a district',
  'survey.text.placeholder': 'Enter your answer...',
  'survey.multi_choice.selected_count': '{count} selected',
  'survey.rating.1': 'Very dissatisfied',
  'survey.rating.2': 'Dissatisfied',
  'survey.rating.3': 'Neutral',
  'survey.rating.4': 'Satisfied',
  'survey.rating.5': 'Very satisfied',
  'survey.rating.aria_label': '{score} points, {label}',
  'survey.rating.placeholder': 'Select a rating',
  'survey.complete.thanks': 'Thank you for your response!',
  'survey.complete.submitted': 'Your survey has been submitted.',
  'survey.error.SVY001.title': 'Survey not found',
  'survey.error.SVY001.content':
    'This survey does not exist or has been removed.',
  'survey.error.SVY002.title': 'This survey is not open yet',
  'survey.error.SVY002.content':
    'Please check the survey link or try again later.',
  'survey.error.SVY003.not_started.title': 'This survey has not started',
  'survey.error.SVY003.not_started.content':
    'It is scheduled to start on {date}.',
  'survey.error.SVY003.ended.title': 'This survey has ended',
  'survey.error.SVY003.ended.content': 'The response period ended on {date}.',
  'survey.error.SVY003.title': 'This survey is not open or has ended',
  'survey.error.SVY003.content': 'Please check the survey open period.',
  'survey.error.SVY009.title': 'This invitation has expired',
  'survey.error.SVY009.content': 'Thank you for your interest.',
  'survey.error.SVY010.title': 'This link does not belong to you',
  'survey.error.SVY010.content':
    'You cannot use this survey link to submit a response.',
  'survey.error.SVYF009.title': 'This store is temporarily unavailable',
  'survey.error.SVYF009.content':
    'Please use another store survey link or try again later.',
  'survey.error.E001.title': 'Invalid survey link',
  'survey.error.E001.content':
    'Please make sure you opened the complete survey link.',
  'survey.error.auth_required.title': 'Unable to open survey',
  'survey.error.auth_required.content':
    'Please complete LINE login before opening the survey.',
  'survey.error.default.title': 'Unable to open survey',
  'survey.error.default.content':
    'Survey validation failed. Please try again later.',
  'survey.filled.title': 'You have already completed this survey',
  'survey.filled.content':
    'This survey can only be completed once. Thank you for participating.',
  'survey.filled.recent.content':
    'You completed this survey on {completedDate}. You can complete it again from {nextOpenDate}.',
} as Record<string, string>;
